// profileService.js - REPLACE THE ENTIRE FILE
import firebase, { auth, db } from '../firebaseConfig.js';


/**
 * Get user profile data
 * @param {string} uid - User ID
 * @returns {Promise<object|null>} User profile data or null
 */
export async function getUserProfile(uid) {
  if (!uid) {
    console.warn("getUserProfile called with no UID");
    return null;
  }
  
  try {
    const docRef = db.collection("userProfiles").doc(uid);
    const docSnap = await docRef.get();
    return docSnap.exists ? docSnap.data() : null;
  } catch (error) {
    console.error("Error getting user profile:", error);
    return null;
  }
}

/**
 * Update user display name
 * @param {string} uid - User ID
 * @param {string} newName - New display name
 * @returns {Promise<boolean>} Success status
 */
export async function updateDisplayName(uid, newName) {
  if (!uid) {
    console.warn("updateDisplayName called with no UID");
    return false;
  }
  
  try {
    await db.collection("userProfiles").doc(uid).update({
      displayName: newName
    });
    return true;
  } catch (error) {
    console.error("Error updating display name:", error);
    return false;
  }
}

/**
 * Check if user is an admin
 * @param {string} uid - User ID
 * @returns {Promise<boolean>} True if user is admin
 */
export async function checkIsAdmin(uid) {
  if (!uid) return false;
  
  try {
    const docRef = db.collection("userProfiles").doc(uid);
    const docSnap = await docRef.get();
    if (!docSnap.exists) return false;
    
    const userData = docSnap.data();
    return userData.role === "admin";
  } catch (error) {
    console.error("Error checking admin status:", error);
    return false;
  }
}

/**
 * Update user consent settings
 * @param {string} uid - User ID
 * @param {boolean} marketingConsent - Marketing consent flag
 * @param {boolean} dataSharingConsent - Data sharing consent flag
 * @returns {Promise<boolean>} Success status
 */
export async function updateUserConsent(uid, marketingConsent, dataSharingConsent) {
  if (!uid) {
    console.warn("updateUserConsent called with no UID");
    return false;
  }
  
  try {
    await db.collection("userProfiles").doc(uid).update({
      marketingConsent,
      dataSharingConsent,
      consentUpdatedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error("Error updating user consent:", error);
    return false;
  }
}

export default {
  getUserProfile,
  updateDisplayName,
  checkIsAdmin,
  updateUserConsent
};